import { useTranslation } from "react-i18next";
import { FeatureSchema, VehicleRequirement } from "../../api/vehicleFeatures";
import { RequirementFields } from "./FeatureFields";

export function OrderRequirementStep({
  schema,
  error,
  reload,
  value,
  onChange,
}: {
  schema?: FeatureSchema;
  error: boolean;
  reload: () => void;
  value: VehicleRequirement[];
  onChange: (value: VehicleRequirement[]) => void;
}) {
  const { t } = useTranslation("workspace");
  const hasRequirements = schema?.definitions.some(
    (d) => !d.archived && d.type !== "string",
  );
  return (
    <section className="rounded-xl border border-border bg-surface-panel p-6">
      <h2 className="text-xl font-semibold">{t("features.requirements")}</h2>
      <p className="my-4 text-sm text-secondary">
        {t("features.creationHelp")}
      </p>
      {error ? (
        <p role="alert" className="text-sm text-danger">
          {t("features.creationLoadError")}{" "}
          <button type="button" className="underline" onClick={reload}>
            {t("features.reload")}
          </button>
        </p>
      ) : !schema ? (
        <p role="status" className="text-sm text-secondary">
          {t("features.loading")}
        </p>
      ) : hasRequirements || value.length ? (
        <RequirementFields
          definitions={schema.definitions}
          value={value}
          onChange={onChange}
        />
      ) : (
        <div className="space-y-3 text-sm text-secondary">
          <p className="font-medium text-text">{t("features.setupTitle")}</p>
          <ol className="list-decimal space-y-2 pl-5">
            <li>
              {t("features.setupStep1")}{" "}
              <a
                href="/settings?tab=vehicle-features"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-brand underline"
              >
                {t("features.setupLink")}
              </a>
            </li>
            <li>{t("features.setupStep2")}</li>
            <li>{t("features.setupStep3")}</li>
          </ol>
          <p>{t("features.setupOptional")}</p>
          <button
            type="button"
            className="font-medium text-brand underline"
            onClick={reload}
          >
            {t("features.refreshDefinitions")}
          </button>
        </div>
      )}
    </section>
  );
}
